export function unSlash(path) {
	path = path.replace(global.config.siteURL, '');
	path = path.replace(global.config.baseURL, '');
	path = path.replace("http://", "http---")
	path = path.replace("https://", "https---")
	path = path.replace("//", "/")
	path = path.replace("http---", "http://")
	path = path.replace("https---", "https://")
	if (path.substr(-1) === '/' && path.length > 1) {
		path = path.substr(0, path.length - 1);
	}
	return path;
}